<template>
<div class="ChannelEdit bgc">
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
            <div class="classes blod">渠道设置</div>
            <div class="container">
                <div class="outbox">
                    <el-form-item label="渠道名称" prop="name" class="videoName">
                        <el-input v-model.trim="item.name" placeholder="请输入渠道名称，不超过45个字" maxlength="40" show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="管理员" class="videoName">
                        <el-autocomplete v-model.trim="item.adminusername" placeholder="请输入选择" :fetch-suggestions="querySearchAsync" @select="handleSelect">
                            <i class="el-icon-caret-bottom el-input__icon" slot="suffix"></i>
                        </el-autocomplete>
                    </el-form-item>
                    <el-form-item label="客服名称" class="videoName">
                        <el-input v-model.trim="item.servicename" placeholder="请输入客服名称，不超过10个字" maxlength="45" show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="客户电话" class="videoName">
                        <el-input v-model.trim="item.servicetel" placeholder="请输入客户电话" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="客服二维码" class="upload-image">
                        <div class="imgBox">
                            <i class="el-icon-picture" v-if="!item.qrcodeatturlid"></i>
                            <img class="activityCoverImage" :src="item.qrcodeatturlid + '?' + time" v-else alt="">
                        </div>
                        <div class="uploadFileBox">
                            <!--<el-button @click.native="openDialog">选择文件</el-button>-->
                            <UploadFile :uploadType="uploadType" @setFile="_setImage" :fileRule="fileRule"></UploadFile>
                            <p>建议尺寸120*120px的JPG、PNG格式， 图片小于2M。</p>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm">提交</el-button>
                        <el-button type="" @click="cancel">取消</el-button>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</div>
</template>

<script>
import UploadFile from 'base/upload/uploadFile2'
import {mapGetters, mapActions} from 'vuex'
import {editChannel, getUserSearchList, getDisChannelView} from  'api/nationalDistribution'
import {nationalDistribution} from 'api/message'
export default {
    name: 'ChannelEdit',
    data() {
        return {
            param: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : '',
            },
            item: {
                innerid: this.$route.query.innerid ? this.$route.query.innerid : '',
                name: '',
                admineventuserid: '',
                adminusername: '',
                servicename: '',
                servicetel: '',
                qrcodeattid: '',
                qrcodeatturlid: ''
            },
            time: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: '.jpg,.jpeg,.png',
                size: 2,
                width: '750',
                height: '420'
            },
            cropperOption: {
                fixedNumber: [120, 120], // 截图框的宽高比例
                enlarge: 1, // 图片根据截图框输出比例倍数
                autoCropWidth: 120, // 默认生成截图框宽度
                autoCropHeight: 120 // 默认生成截图框高度
            },
            rules: {
                name: [
                    {required: true, message: '请输入渠道名称', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        if (this.item.innerid) {
            this._getView()
        }
    },
    methods: {
        querySearchAsync(queryString, cb) {
            let results = []
            getUserSearchList({
                data: {
                    keywords: queryString,
                    eventinnerid: this.param.eventinnerid,
                    page: 1,
                    pagesize: 10
                },
                success: data => {
                    data.data.content.forEach(obj => {
                        obj.value = obj.customername
                    })
                    results = data.data.content
                    cb(results)
                },
                error: () => {
                    cb(results)
                }
            })
        },
        handleSelect(obj) {
            this.item.admineventuserid = obj.innerid
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.time = new Date().getTime()
            this.item.qrcodeattid = file.key
            this.item.qrcodeatturlid = file.furl
        },
        submitForm() {
            this.$refs.formName.validate((valid) => {
                if (valid) {
                    this._edit()
                }
            })
        },
        cancel() {
            this.$confirm(nationalDistribution.cancelEdit.msg, nationalDistribution.cancelEdit.title, {
                confirmButtonText: nationalDistribution.cancelEdit.confirmText,
                cancelButtonText: nationalDistribution.cancelEdit.cancelText
            }).then(() => {
                this.$router.back()
            }).catch(() => {})
        },
        _edit() {
            this.setLoading(true)
            editChannel({
                data: Object.assign({}, this.param, this.item),
                success: () => {
                    this.setLoading(false)
                    this.$message.success('保存成功')
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getDisChannelView({
                data: Object.assign({}, this.param, this.item),
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UploadFile
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ChannelEdit {
    .form{
        margin-top: 0;
    }
    padding: 20px;
    .upload-image{
        .el-form-item__content {
            display: flex;
            align-items: center;
            .imgBox{
                width: 120px;
                height: 120px;
                background: #F5F7FA;
                text-align: center;
                line-height: 120px;
                margin-right: 30px;
                .el-icon-picture{
                    color: #DCDFE6;
                    font-size: 40px;
                }
                .activityCoverImage{
                    width: 120px;
                    height: 120px;
                }
            }
        }
    }
    .el-autocomplete{
        width: 100%;
    }
    .container{
        border-top: 2px solid  #F5F7FA ;
        padding-top: 20px;
    }
    .outbox{
        width: 800px;
    }
}
</style>
